Ext.define('SA.data.UserImports', {
    extend: 'Ext.util.Observable',

    singleton: true,

    async loadAll() {
        await SA.data.UserDatasets.loadAll();

        return SA.data.UserAttributes.loadAll();
    },

    refresh() {
        return this.loadAll();
    }
});